import { put } from "@redux-saga/core/effects";

import { FieldsService } from "../../../services/fields";

import { deleteMarkerFailure, deleteMarkerSuccess } from "../actionCreaters";
import { DeleteMarkerRequestActionType, markersResponse } from "../types";

export function* deleteMarkerSaga({ payload: { fieldId, markerId } }: DeleteMarkerRequestActionType) {
    try {
        const {
            data: { data },
        }: markersResponse = yield FieldsService.deleteMarker(fieldId, markerId);

        yield put(deleteMarkerSuccess({ fieldId, markers: data.markers }));
    } catch (error) {
        yield put(deleteMarkerFailure({ fieldId: fieldId }));
        // yield put(Handle Error);
    }
}
